import { Observable } from 'rxjs';
import { IPaymentModes } from '../static/static';


// Note: Using 'any' for domain types to avoid circular dependencies between 
// @mavles/shared and domain libraries (@mavles/contacts, @mavles/accounts, etc.)
// These models are maintained in their respective domain libraries.

export interface IConfigHeader {
  config_header_id: number;
  config_header_name: string;
  config_header_status: number;
  items: IConfigItems[];
}

export interface IConfigItems {
  config_id: number;
  config_header_id: number;
  config_name: string;
  config_label: string;
  config_input_type: string;
  config_class: string;
  config_value: any;
  config_status: number;
  config_changed: boolean;
}

export interface IStaticTable {
  static_table_id: number;
  static_table_name: string;
  static_table_description: string;
  items: IStaticItems[];
}

export interface IStaticItems {
  static_item_id: number;
  static_table_id: number;
  static_item_name: string;
  static_item_value: string;
  static_item_description: string;
}

export class StaticItems implements IStaticItems {
  static_item_id!: number;
  static_table_id!: number;
  static_item_name!: string;
  static_item_value!: string;
  static_item_description!: string;
}

export class StaticTable implements IStaticTable {
  static_table_id!: number;
  static_table_name!: string;
  static_table_description!: string;
  items!: IStaticItems[];
}

export class AppConfigData {
  static config$?: Observable<AppConfigData>;
  contactTypes: any[] = [];
  addressTypes: string[] = [];
  paymentModes: IPaymentModes[] = [];
  expenseCategory: any[] = [];
  expenseCategoryItems: any[] = [];
  expenseCategoryItemsVW: any[] = [];
  orderElements: any[] = [];
  orderAccounts: any[] = [];
  wallets: any[] = [];
  orderElementContactMap: any[] = [];
  worksheetProducts: any[] = [];
  roles: any[] = [];
}
